module.exports = __webpack_public_path__ + "static/lawrence_thompson-b2c072d27321a7ed1f6038be75b87316.png";